import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { APP_URL } from 'core';
import { LabelButton, TextLink } from '@teamsnap/snap-ui';
import { AuthContext, User } from 'auth';
import {
  DemoType,
  TeamsnapAppConfirmationModal,
  TeamsnapAppFeatureCallout,
  useTeamsnapAppAdUpsellActions,
} from './shared';

const learnMoreLink =
  'https://teamsnapwebsitebuilder.teamsnapsites.com/website-builder-packages/';

type RouteParams = { orgId: string };

const Websites: React.FC<RouteComponentProps<RouteParams>> = ({
  match: {
    params: { orgId },
  },
}) => {
  React.useEffect(() => {
    window.scrollTo({
      top: 0,
    });
  }, []);

  const { user } = React.useContext(AuthContext);
  const [showModal, toggleModal] = React.useState(false);

  const [learnMore, sendEmailRequest] = useTeamsnapAppAdUpsellActions(
    user as User,
    DemoType.Websites,
    orgId
  );

  return (
    <div id="websites">
      <TeamsnapAppConfirmationModal
        show={showModal}
        onClose={() => toggleModal(false)}
      >
        <h2 className="sui-heading-md sui-mb-2">Got it!</h2>
        <p>
          We will email you soon to set up your demo and answer any questions
          you might have.
        </p>
      </TeamsnapAppConfirmationModal>
      <div className="page-content sui-p-4">
        <header className="sui-flex sui-flex-col d:sui-flex-row d:sui-justify-between sui-mb-4 sui-gap-2">
          <div>
            <h2 className="sui-heading-md">TeamSnap Website Builder</h2>
            <TextLink
              href={learnMoreLink}
              onClick={(e) => {
                e.preventDefault();
                learnMore(learnMoreLink);
              }}
            >
              Learn More
            </TextLink>
          </div>
          <div>
            <LabelButton
              icon="add"
              iconPosition="left"
              labelText="Request a demo"
              sentiment="default"
              size="default"
              variantType="primary"
              onClick={() => sendEmailRequest(() => toggleModal(true))}
            />
          </div>
        </header>

        <div className="sui-flex-col d:sui-flex-row sui-flex sui-gap-3">
          <TeamsnapAppFeatureCallout>
            Built-in TeamSnap Integrations
          </TeamsnapAppFeatureCallout>
          <TeamsnapAppFeatureCallout>
            Build your own or hire a designer
          </TeamsnapAppFeatureCallout>
          <TeamsnapAppFeatureCallout>
            Beautiful on desktop and mobile
          </TeamsnapAppFeatureCallout>
        </div>
        <div className="sui-flex sui-flex-col d:sui-flex-row sui-gap-[64px] sui-mt-4 d:sui-mt-6 sui-items-center">
          <div className="sui-w-full d:sui-w-1/2 sui-body">
            <h1 className="sui-heading-md sui-mb-2">
              Create a professional, responsive website with built-in TeamSnap
              integrations
            </h1>
            <p className="sui-mb-2">
              Need a great-looking website to promote your organization and
              share info with your fans? TeamSnap Website Builder offers the
              easy-to-use tools you need to create a site for your organization
              where you can promote and collect registrations, connect with your
              community, and share schedules & results with fans.
            </p>
            <p className="sui-mb-2">
              Choose from one of our SEO-optimized templates and then you can
              use the drag-and-drop builder to build the site yourself or opt
              for one of our website design experts to do it for you.
            </p>
          </div>
          <div className="sui-w-full d:sui-w-1/2 sui-relative">
            <img
              id="content-image"
              alt="phone"
              src={`${APP_URL}/images/websites-builder-image.png`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Websites;
